import type { GridColDef } from '@mui/x-data-grid';

import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { getTaskCheckTypeData } from '@/constants/options/task-check-type.option';
import type { TaskCheckTypeEnum } from '@/types/enums/task-check-type.enum';
import { dateUtils } from '@/utils/date';

export const columns = (): GridColDef[] => [
    {
        field: 'name',
        headerName: 'Tên loại Task',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.row.name} />,
    },
    {
        field: 'taskCheckTypeEnum',
        headerName: 'Loại',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params =>
            getTaskCheckTypeData({
                status: params.value as TaskCheckTypeEnum,
                showChip: false,
            }).label,
    },
    {
        field: 'templateCheck',
        headerName: 'Loại phiếu biểu mẫu',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.templateCheck?.name} />
        ),
    },
    {
        field: 'description',
        headerName: 'Mô tả',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 300,
        renderCell: params => <HoverCopyCell value={params.row.description} />,
    },
    {
        field: 'createdDate',
        headerName: 'Ngày tạo',
        editable: false,
        sortable: true,
        minWidth: 150,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
    },
];
